module.exports = __webpack_public_path__ + "img/imgdashboard.8a6b0d08.png";